import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileManagerRenameInput } from '../filemanager.models';
import { FileManagerService } from '../filemanager.service';

@Component({
    selector: 'pcode-rename-dialog',
    templateUrl: './rename-dialog.component.html',
    styleUrls: ['./rename-dialog.component.scss'],
    standalone: false
})
export class FileManagerRenameDialogComponent implements OnInit
{
	// rename form
	_form: UntypedFormGroup = this.fb.group(
		{
			name: [null, [Validators.required]]
		});
	get name() { return this._form.get('name'); }

	// constructor
	constructor
		(
			private dialogRef: MatDialogRef<FileManagerRenameDialogComponent>,
			@Inject(MAT_DIALOG_DATA) private model: FileManagerRenameInput,
			private fb: UntypedFormBuilder,
			private fileManagerService: FileManagerService
		)
	{
	}

	// on init
	ngOnInit()
	{
		this.name.setValue(this.model.name);
	}

	// rename
	rename()
	{
		this._form.markAllAsTouched();

		if (this._form.valid)
		{
			switch (this.model.type)
			{
				// renaming folder
				case 'folder': {
					this.fileManagerService.renameFolder(this.model.id, this.name.value).subscribe(
						() =>
						{
							this.dialogRef.close({ success: true })
						},
						error =>
						{
							this.dialogRef.close({ success: false, error: error })
						}
					);
				}
					break;

				// renaming file
				case 'file': {
					this.fileManagerService.renameFile(this.model.id, this.name.value).subscribe(
						() =>
						{
							this.dialogRef.close({ success: true })
						},
						error =>
						{
							this.dialogRef.close({ success: false, error: error })
						}
					);
				}
					break;
			}

		}
	}

	// close dialog
	closeDialog()
	{
		this.dialogRef.close({ created: false });
	}
}
